import { useMatches } from 'react-router';

import { usePageWhatsAppOverride } from '@/stores/pageContextStore';

/**
 * A route says what a WhatsApp message from that page should say, with
 * `export const handle = { whatsappMessage: '…' }`. Pages that show one car
 * override it with the car's own details.
 */
export type WhatsAppRouteHandle = { whatsappMessage?: string };

const DEFAULT_MESSAGE = 'Hello Kabex Motors, I would like some help choosing a car.';

export function usePageWhatsAppMessage(): string {
  const override = usePageWhatsAppOverride();
  const matches = useMatches();
  if (override) return override;
  for (let i = matches.length - 1; i >= 0; i -= 1) {
    const message = (matches[i]?.handle as WhatsAppRouteHandle | undefined)?.whatsappMessage;
    if (message) return message;
  }
  return DEFAULT_MESSAGE;
}
